import DocumentTemplate from "./DocumentTemplate";

export default DocumentTemplate;
